import { useQuery } from "@tanstack/react-query";
import api from "../../../api/api";
import { QUERY_ONBOARDING_KEY } from "../../../api/queryKeys";

export default function useGetOnboarding() {
  return useQuery<any>([QUERY_ONBOARDING_KEY], () =>
    api.get(QUERY_ONBOARDING_KEY).then((res) => res.data)
  );
}
